import { ProductListPage } from '~/components/ProductListPage/ProductListPage'

export default function ProductsPage() {
  return <ProductListPage />
}